const enc = encodeURIComponent;
export class FoodOnboardingReviewApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Create a submission (pending) for the reviewer queue (operator). */
    createSubmission(input) {
        return this.client.request({ method: 'POST', path: '/v1/food-onboarding-review/submissions', body: input, auth: true });
    }
    /** The open reviewer queue — submissions not yet approved, newest first (operator). */
    listOpen() {
        return this.client.request({ method: 'GET', path: '/v1/food-onboarding-review/submissions', auth: true });
    }
    /** A submission + its current version + its full append-only audit trail (operator). */
    get(submissionId) {
        return this.client.request({ method: 'GET', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}`, auth: true });
    }
    /** The signed-in reviewer claims a pending submission (operator). */
    claim(submissionId) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/claim`, body: {}, auth: true });
    }
    /** Approve as the signed-in reviewer — four-eyes on a high-risk kind (a second, different reviewer settles it). */
    approve(submissionId, reasonCode, note) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/approve`, body: { reasonCode, ...(note !== undefined ? { note } : {}) }, auth: true });
    }
    /** Reject as the signed-in reviewer, who is recorded as the rejecter (operator). */
    reject(submissionId, reasonCode, note) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/reject`, body: { reasonCode, ...(note !== undefined ? { note } : {}) }, auth: true });
    }
    /** Request changes from the subject as the signed-in reviewer (operator). */
    requestChanges(submissionId, reasonCode, note) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/request-changes`, body: { reasonCode, ...(note !== undefined ? { note } : {}) }, auth: true });
    }
    /** The subject resubmits after a request-changes, returning the submission to pending (operator). */
    resubmit(submissionId) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/resubmit`, body: {}, auth: true });
    }
    /** Resolve an appeal against a rejection as the signed-in reviewer — distinct from the rejecter and the submitter. */
    appeal(submissionId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-onboarding-review/submissions/${enc(submissionId)}/appeal`, body: input, auth: true });
    }
}
//# sourceMappingURL=food-onboarding-review.js.map